import "core-js/modules/es.object.define-property.js";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var isBrowser = typeof window !== 'undefined';
export var KeyManager = /*#__PURE__*/function () {
  function KeyManager() {
    _classCallCheck(this, KeyManager);
  }

  _createClass(KeyManager, null, [{
    key: "getAccessToken",
    value: function getAccessToken() {
      return isBrowser ? localStorage.getItem(this.LOCAL_STORAGE_ACCESS) : this.access_token;
    }
  }, {
    key: "setAccessToken",
    value: function setAccessToken(token) {
      if (isBrowser) {
        localStorage.setItem(this.LOCAL_STORAGE_ACCESS, token);
      } else {
        this.access_token = token;
      }
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      return isBrowser ? localStorage.getItem(this.LOCAL_STORAGE_REFRESH) : this.refresh_token;
    }
  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(token) {
      if (isBrowser) {
        localStorage.setItem(this.LOCAL_STORAGE_REFRESH, token);
      } else {
        this.refresh_token = token;
      }
    }
  }, {
    key: "prepareAuthHeaders",
    value: function prepareAuthHeaders(headersInit) {
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // @ts-ignore

      var headers = headersInit || {};
      console.log('access token', this.getAccessToken());
      var accessToken = this.getAccessToken();
      var refreshToken = this.getRefreshToken();

      if (refresh && refreshToken) {
        headers['Authorization'] = "Bearer ".concat(refreshToken);
      } else if (accessToken) {
        headers['Authorization'] = "Bearer ".concat(accessToken);
      }

      return headers;
    }
  }, {
    key: "getHeaders",
    value: function getHeaders() {
      var headers = {};
      var accessToken = this.getAccessToken();
      var refreshToken = this.getRefreshToken();

      if (accessToken) {
        headers[this.X_SNEK_API_TOKEN] = accessToken;
      }

      if (refreshToken) {
        headers[this.X_SNEK_API_REFRESH_TOKEN] = refreshToken;
      }

      return headers;
    }
  }, {
    key: "clearTokens",
    value: function clearTokens() {
      if (isBrowser) {
        localStorage.removeItem(this.LOCAL_STORAGE_ACCESS);
        localStorage.removeItem(this.LOCAL_STORAGE_REFRESH);
      } else {
        this.access_token = null;
        this.refresh_token = null;
      }
    }
  }]);

  return KeyManager;
}();

_defineProperty(KeyManager, "LOCAL_STORAGE_KEY", 'snek-auth');

_defineProperty(KeyManager, "LOCAL_STORAGE_ACCESS", KeyManager.LOCAL_STORAGE_KEY + '/access_token');

_defineProperty(KeyManager, "LOCAL_STORAGE_REFRESH", KeyManager.LOCAL_STORAGE_KEY + '/refresh_token');

_defineProperty(KeyManager, "X_SNEK_API_TOKEN", 'X-SNEK-API-TOKEN'.toLocaleLowerCase());

_defineProperty(KeyManager, "X_SNEK_API_REFRESH_TOKEN", 'X-SNEK-API-REFRESH-TOKEN'.toLocaleLowerCase());

_defineProperty(KeyManager, "access_token", null);

_defineProperty(KeyManager, "refresh_token", null);